var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col"},[_c('validation-provider',{ref:"start-date-validator",staticClass:"mt-2 w-full",attrs:{"rules":{
          required: true,
          date_format: 'YYYY-MM-DD',
          after_date: {
            minDate: _vm.dates.start,
            included: true,
            format: 'YYYY-MM-DD',
          },
          before_date: {
            maxDate: _vm.endDate,
            included: false,
            format: 'YYYY-MM-DD',
          },
        },"vid":"startDate"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('vs-input',{attrs:{"label":"From (YYYY-MM-DD)","disabled":_vm.disabled},on:{"input":_vm.validateAndEmitDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_c('span',{staticClass:"text-danger text-sm"},[_vm._v(_vm._s(errors[0]))])]}}])})],1),_c('div',{staticClass:"vx-col"},[_c('validation-provider',{ref:"end-date-validator",staticClass:"mt-2 w-full",attrs:{"rules":{
          required: true,
          date_format: 'YYYY-MM-DD',
          after_date: {
            minDate: _vm.startDate,
            included: false,
            format: 'YYYY-MM-DD',
          },
          before_date: {
            maxDate: _vm.dates.end,
            included: true,
            format: 'YYYY-MM-DD',
          },
        },"vid":"endDate"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('vs-input',{attrs:{"label":"To (YYYY-MM-DD)","disabled":_vm.disabled},on:{"input":_vm.validateAndEmitDates},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_c('span',{staticClass:"text-danger text-sm"},[_vm._v(_vm._s(errors[0]))])]}}])})],1)]),(_vm.filteredEvents && _vm.filteredEvents.length > 0)?_c('div',{staticClass:"vx-row mt-4 pl-2"},_vm._l((_vm.filteredEvents),function(event,index){return _c('div',{key:index,staticClass:"mx-2",on:{"click":function($event){return _vm.selectEvent(index)}}},[_c('vs-chip',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
          content: _vm.getEventTooltipContent(index),
          boundariesElement: 'window',
        }),expression:"{\n          content: getEventTooltipContent(index),\n          boundariesElement: 'window',\n        }"}],staticClass:"text-sm md:text-base",class:[
          { 'event-chip': !_vm.disabled },
          { 'event-chip-disabled': _vm.disabled },
          { 'text-primary': _vm.selectedEventIndex != index },
        ],attrs:{"color":"primary","transparent":_vm.selectedEventIndex != index},on:{"mouseenter":_vm.logTooltip}},[_c('vs-avatar',{attrs:{"icon":"event"}}),_vm._v(" "+_vm._s(event.name)+" ")],1)],1)}),0):_vm._e(),_c('div',{staticClass:"vx-row mt-4 px-4"},[_c('vs-button',{attrs:{"color":"primary","type":"border","disabled":(_vm.startDate == _vm.dates['start'] && _vm.endDate == _vm.dates['end']) || _vm.disabled},on:{"click":_vm.resetButton}},[_vm._v("Full period")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }